import { Button } from '@consta/uikit/Button'
import { Responses500 } from '@consta/uikit/Responses500'
import { Link } from 'react-router-dom'

import type { ErrorComponent } from './types'

export const SomeError: ErrorComponent = ({ onSelectAction }) => {
  return (
    <Responses500
      actions={
        <Link to="/">
          <Button
            view="ghost"
            label="Вернуться к проектам"
            type="button"
            onClick={onSelectAction}
          />
        </Link>
      }
    />
  )
}
